import SettingsMenuRow from "./SettingsMenuRow";

export default function SettingsMenuGroup({
  label,
  items,
  itemStateMap = {},
  onSelect,
  showIcons = true,
}) {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <section className="lz-settings-group">
      {label ? <p className="lz-settings-group__label">{label}</p> : null}

      <div className="lz-settings-group__rows">
        {items.map((item, index) => {
          const state = itemStateMap[item.id] || {};

          return (
            <SettingsMenuRow
              key={item.id}
              label={item.label}
              description={item.menuDescription ?? item.description}
              icon={item.icon}
              showIcon={showIcons}
              badge={state.badge}
              meta={state.meta}
              showSeparator={index > 0}
              onClick={() => onSelect(item)}
            />
          );
        })}
      </div>
    </section>
  );
}
